import store from '@/stores/store';
import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import allutils from '@/utils'
import providers from "./submodules/providers";
import producttypes from "./submodules/producttypes";


const state = {
    product: null,
    product_loading: false,
    product_loading_errors: null,
    product_deleting: false,

    product_saving: false,
    product_saving_errors: {},

    producttype: null,

    purchaseprices: [],
    purchaseprices_count: 0,
    purchaseprices_loading: false,
    purchaseprices_loading_errors: null,
    purchaseprices_saving: false,
    purchaseprices_saving_errors: null,
};

const mutations = {

    updateProduct(state, product) {
        state.product_saving = false;
        state.product_saving_errors = {};

        if (product && state.product && product.id && state.product.id) {
            state.product = product;
            return;
        }
        state.purchaseprices = [];
        state.purchaseprices_count = 0;
        state.purchaseprices_loading_errors = null;
        state.product = product;
        state.producttype = product.producttype;
    },


    updateProductType(state, producttype) {
        const next =
            producttype === undefined || producttype === ""
                ? null
                : producttype;
        state.producttype = next;
        state.product.producttype = next;
        if (next == null) {
            state.product.metadata = {};
        }
    },

    updateProductLoading(state, loading) {
        state.product_loading = loading;
    },
    updateProductLoadingErrors(state, errors) {
        state.product_loading_errors = errors;
    },

    updateProductSavingErrors(state, errors) {
        state.product_saving = false;
        state.product_saving_errors = errors;
    },
    updateProductSaving(state, saving) {
        state.product_saving = saving;
    },

    updatePurchasePrices(state, purchaseprices) {
        state.purchaseprices = purchaseprices;
    },
    updatePurchasePricesCount(state, count) {
        state.purchaseprices_count = count;
    },
    updatePurchasePricesLoading(state, loading) {
        state.purchaseprices_loading = loading;
    },
    updatePurchasePricesLoadingErrors(state, errors) {
        state.purchaseprices_loading_errors = errors;
    },
    updatePurchasePricesSavingErrors(state, errors) {
        state.purchaseprices_saving = false;
        state.purchaseprices_saving_errors = errors;
    },
    updatePurchasePricesSaving(state, saving) {
        state.purchaseprices_saving = saving;
    },
    updateProductProviders(state, providers) {
        state.product.providers = providers;
        if (state.product.provider) {
            if (providers) {
                state.product.provider = providers[0].provider;
                state.product.unit_amount = providers[0].unit_amount;
            } else {
                state.product.provider = null;
                state.product.unit_amount = null;
            }
        }
    },
    updateProductUPC(state, upc) {
        if (state.product) {
            state.product = { ...state.product, upc: upc };
        }
    }
};

const actions = {


    async fetchProduct({ commit, dispatch, state }, params) {
        commit('updateProductLoading', true);

        let url = state.product.provider ?
            `/api/providerproducts/${state.product.id}/` :
            `/api/products/${state.product.id}/`;

        try {
            const response = await axios.get(url);
            commit('updateProduct', response.data);
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateProductLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateProductLoading', false);
        }
    },

    async saveProduct({ commit, dispatch, state }, params) {
        let url = state.product.provider ? '/api/providerproducts/' : '/api/products/';
        commit('updateProductSaving', true);
        commit('updateProductSavingErrors', {});
        let method = axios.put;
        const producttype = state.producttypes.producttypes.find((item) => item.id === state.product.producttype);
        state.product.metadata = allutils.cleanupMetadata(state.product.metadata, producttype);
        // Explicit null so clearing product type is persisted (JSON drops undefined).
        if (state.product.producttype === undefined || state.product.producttype === "") {
            state.product.producttype = null;
        }
        // The unit selects always hold a value: an empty quantity means
        // "no content", so drop the dangling unit instead of sending it.
        if (!state.product.piece_content_quantity) {
            state.product.piece_content_quantity = null;
            state.product.piece_content_unit = null;
        }
        if (!state.product.sale_unit_content_quantity) {
            state.product.sale_unit_content_quantity = null;
            state.product.sale_unit_content_unit = null;
        }
        if (state.product?.id) {
            url += `${state.product.id}/`;
            delete (state.product.providers);
            method = axios.put;
        } else {
            method = axios.post;
        }
        try {
            let response;
            if (!state.product.id && params?.inventoryCreation) {
                const inventory = params.inventoryCreation;
                response = await axios.post(`/api/inventories/${inventory.id}/create-product/`, {
                    generation: inventory.generation, item_id: inventory.itemId, product: state.product,
                });
                response = { ...response, data: { ...state.product, id: response.data.item.product_id,
                    is_service: false, stock_tracking: true, inventory_item: response.data.item } };
            } else {
                response = await method(url, state.product);
            }
            commit('updateProduct', response.data);
            dispatch('session/fetchStats', null, { root: true });
            return response;
        } catch (xhr_error) {
            let error = utils.handleError(xhr_error);
            commit('updateProductSavingErrors', error.details);
            throw error;
        } finally {
            commit('updateProductSaving', false);
        }
    },

    async init({ commit, dispatch, state }, params) {
        let default_stock_tracking = !!store.state.session.stats.stocks;

        let product =
        {
            available_for_sale: true,
            stock_tracking: default_stock_tracking,
            metadata: {},
            purchase_prices: [],
            packaging: store.state.session.settings.default_packaging,
            format: store.state.session.settings.default_format || null,
            format_data: null,
            tags: [],
            // Seed unit-related keys so Vue 2 makes them reactive: assigning
            // a missing key later (via v-model) would not trigger re-renders.
            producttype: null,
            commercial_name: null,
            stock_unit: 'pc',
            piece_content_quantity: null,
            piece_content_unit: null,
            sale_unit: null,
            sale_format: null,
            sale_format_data: null,
            sale_unit_content_quantity: null,
            sale_unit_content_unit: null,
            low_stock_alert_treshold: 0,
            ...JSON.parse(
                JSON.stringify(
                    params.product || { purchase_prices: [], metadata: {} }
                )
            )
        };
        if (!Array.isArray(product.tags)) {
            product.tags = [];
        }
        if (
            product.low_stock_alert_treshold === null
            || product.low_stock_alert_treshold === undefined
        ) {
            product.low_stock_alert_treshold = 0;
        }
        if (product.provider) {
            product.providers = [{ provider: product.provider, unit_amount: null }];
        }
        commit('updateProduct', product);

        dispatch('providers/init', { filters: { limit: 1000, connected: false, ordering: 'name', exclude_profile: "operator" }, url: `/api/providers/`, });
        dispatch('providers/fetchProviders');

        dispatch('producttypes/init');
        dispatch('producttypes/fetchProductTypes');

        // Fetch next UPC if product is new or doesn't have a UPC
        const isNew = !product.id;
        if (isNew && (!product.upc || (typeof product.upc === "string" && product.upc.trim() === ""))) {
            try {
                await dispatch('fetchNextUPC');
            } catch (error) {
                // Error is already logged in the fetchNextUPC action
            }
        }
    },

    async fetchNextUPC({ commit, state }) {
        try {
            const response = await axios.get("/api/products/nextupc/");
            if (response.data && response.data.upc) {
                commit('updateProductUPC', response.data.upc);
            }
        } catch (error) {
            console.error("Failed to fetch next UPC:", error);
            throw error;
        }
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        providers: providers(),
        producttypes: producttypes(),
    }
};

